// ParagraphAtom.tsx
import React, { useState } from "react";

// ASSETS

// STYLES
import { CardWrapper, PdfWrapper } from "./ParagraphAtomStyled";

// LIBRARIES
import Skeleton from "react-loading-skeleton";

// MISC
import { IProps } from "./ParagraphAtomModel";
import { TextType } from "../CustomText/CustomTextModel";
import { COLORS, SIZE } from "constants/variables";

// REDUX
import { useSelector } from "react-redux";
import { accessibilityBiggerCursorSelector } from "slices/UISlice/uiSliceSelectors";

// COMPONENTS
import CustomText from "../CustomText/CustomText";

const ParagraphAtom = (props: IProps) => {
  // PROPERTIES
  const { text, href } = props;

  // LIBRARY CONSTANTS
  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);

  // STATE CONSTANTS
  const [isHover, setIsHover] = useState<boolean>(false);
  const isLoading = !text;

  // API REQUESTS

  // LIFE CYCLE

  // EVENT HANDLERS

  return (
    <>
      {!isLoading ? (
        <CardWrapper href={href}>
          {href ? (
            <PdfWrapper
              biggerCursor={href ? biggerCursor : null}
              href={href}
              target={href?.endsWith(".pdf") ? "_blank" : "_self"}
              onMouseEnter={() => setIsHover(true)}
              onMouseLeave={() => setIsHover(false)}
            >
              <CustomText
                text={text}
                type={TextType.H5}
                color={isHover ? COLORS.FaluRed : COLORS.VividAuburn}
              />
            </PdfWrapper>
          ) : (
            <CustomText text={text} type={TextType.H5} />
          )}
        </CardWrapper>
      ) : (
        <CardWrapper>
          <Skeleton height={SIZE.max32} />
        </CardWrapper>
      )}
    </>
  );
};

export default ParagraphAtom;
